export default __webpack_public_path__ + "static/bigminer-qr-pricing-d780b5c17d409c5d12f7c5b7ee9420af.svg";